export default __webpack_public_path__ + "static/media/balance.cfd7a92b.svg";